// extracted by mini-css-extract-plugin
export default {"inputBox":"LDDQhmu4GxDuA1z35AAm"};